"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'Tag',
    props: {
        tag: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            required: true,
        },
        type: {
            type: String,
        },
    },
    methods: {
        getClasses() {
            const classes = ['tag-count', 'tooltip', 'tooltip-bottom'];
            classes.push(`tag-${this.tag}`);
            if (this.size !== undefined) {
                classes.push(`tag-size-${this.size}`);
            }
            if (this.type !== undefined) {
                classes.push(`tag-type-${this.type}`);
            }
            return classes.join(' ');
        },
    },
});
